export default "__VITE_ASSET__f3xpQ9Do__"